import { Delete } from "@mui/icons-material";
import { TFunction } from "react-i18next";

import { ConfirmButton } from "../../../components/Controls/ConfirmButton";
import { WorkOrderOverview } from "../../../models/workorder/WorkOrder";
import {
    DeleteWorkOrderListCallback,
    EditWorkOrderListCallback,
} from "../../../service/WorkOrderService";
import { createActionsColumn } from "../../../utils/datagrid.utils";
import { EditDialog } from "../Dialog/EditDialog";

interface Options {
    canEdit: boolean;
    editWorkOrder: EditWorkOrderListCallback;
    deleteWorkOrder: DeleteWorkOrderListCallback;
    t: TFunction;
}

export function getWorkOrdersListActions({
    canEdit,
    editWorkOrder,
    deleteWorkOrder,
    t,
}: Options) {
    return createActionsColumn<WorkOrderOverview>(params => {
        const row = params.row;

        let confirmText = t("pages.workorder.index.warning_remove");
        if (row.containsControlPointUsages) {
            confirmText +=
                "\n\n" + t("pages.workorder.index.warning_remove_cp");
        }

        const actions = [];
        if (canEdit) {
            actions.push(
                <EditDialog
                    key={`workorders_action_edit_${row.id}`}
                    workOrder={row}
                    editWorkOrder={editWorkOrder}
                />,
            );
            actions.push(
                <ConfirmButton
                    key={`workorders_action_delete_${row.id}`}
                    confirmText={confirmText}
                    onConfirm={() => deleteWorkOrder(row.id)}
                    color="error"
                    icon
                    isDanger
                >
                    <Delete />
                </ConfirmButton>,
            );
        }
        return actions;
    });
}
